"use strict";
/* eslint-disable @typescript-eslint/naming-convention */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrate = void 0;
function migrate(old) {
    delete old.repository;
    return __assign(__assign({}, old), { __type: "Web3ApiManifest", format: "0.0.1-prealpha.5" });
}
exports.migrate = migrate;
//# sourceMappingURL=0.0.1-prealpha.4_to_0.0.1-prealpha.5.js.map